import styled from "styled-components";

export const SpaceAtom = styled.div<{
  direction: string;
  gap: number;
  height: string;
  width: string;
  fitParent: boolean;
  align: string;
  column: boolean;
  center: boolean;
  justify: string;
  padding: number | string;
  position: string;
}>`
  display: flex;
  flex-direction: ${(p) => (p.column ? "column" : p.direction)};
  justify-content: ${(p) => p.justify};
  align-items: ${(p) => (p.center ? "center" : p.align)};
  position: ${(p) => (p.position ? p.position : "relative")};
  height: ${(p) => (p.fitParent ? "100%" : p.height)};
  width: ${(p) => (p.fitParent ? "100%" : p.width)};
  padding: ${(p) =>
    typeof p.padding === "number" ? `${p.padding}px` : p.padding};
  > * {
    margin: ${(p) =>
      p.direction === "column" || p.column
        ? `0 0 ${p.gap}px 0 !important`
        : `0 ${p.gap}px 0 0 !important`};
    &:last-child {
      margin: unset !important;
    }
  }
  &.uncertified-card-wrapper {
    justify-content: flex-start;
  }
  @media (max-width: 1500px) {
    &.certified-company-wrapper {
      flex-direction: column;
      .certified-company-card {
        margin-top: 16px !important;
      }
    }
    &.certified-person-wrapper {
      flex-direction: column;
    }
    &.uncertified-card-wrapper {
      flex-direction: column;
      .uncertified-card {
        width: 100%;
        margin-top: 16px !important;
      }
    }
  }
`;
